module.exports = __webpack_public_path__ + "media/site_templates/www.localbathroomrenovations.net.au/images/feature_2-87f39afd27a6de39e13fbda5af5cfa69.jpeg";